<template>
  <div class="userinfo">
    <header-bar :name='activeTab+"报名"' :page="'userinfo'"></header-bar>
    <div class="content">
      <div class="top_content clearfix">
        <div class="tip">
          {{getUserInfo.username}} 您好！您是第一次上传作品，请补充参赛信息，谢谢！
        </div>
        <div class="tab" :class="{ 'active': activeTab == '志愿者'}"  @click="changeTab('志愿者')">志愿者</div>
        <div class="tab" :class="{ 'active': activeTab == '非志愿者'}" @click="changeTab('非志愿者')">非志愿者</div>
      </div>
      <div class="formItem clearfix">
        <div class="formName">姓名</div>
        <div class="formIcon">
          <img src="../img/m/arrow_right.png" alt="" class="arrow">
        </div>
        <div class="formCon">
          <input type="text" placeholder="" v-model="infoForm.realname">
        </div>
      </div>
      <div class="formItem clearfix">
        <div class="formName">性别</div>
        <div class="formIcon">
          <img src="../img/m/arrow_right.png" alt="" class="arrow">
        </div>
        <div class="formCon" :class="{'conHolder': !infoForm.gender}" @click="showSexPicker = true">
         {{infoForm.gender ? sexColumns.find(v => infoForm.gender == v.id).text : '请选择'}}
        </div>
        <van-popup v-model="showSexPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="sexColumns"
            @confirm="onConfirmSex"
            @cancel="showSexPicker = false"
          />
        </van-popup>
      </div>
      <div class="formItem clearfix">
        <div class="formName">国家</div>
        <div class="formIcon">
          <img src="../img/m/arrow_right.png" alt="" class="arrow">
        </div>
        <div class="formCon" :class="{'conHolder': !infoForm.country}" @click="showCountryPicker = true">
          {{infoForm.country ? countryList.find(v => infoForm.country == v.skey).cn : '请选择'}}
        </div>
        <van-popup v-model="showCountryPicker" position="bottom">
          <van-picker
            show-toolbar
            value-key='cn'
            :columns="countryList"
            @confirm="onConfirmCountry"
            @cancel="showCountryPicker = false"
          />
        </van-popup>
      </div>
      <!-- <div class="formItem clearfix" v-if="activeTab == '志愿者'">
        <div class="formName">任教学校</div>
        <div class="formIcon">
          <img src="../img/m/arrow_right.png" alt="" class="arrow">
        </div>
        <div class="formCon" :class="{'conHolder': !infoForm.school}" @click="showSchoolPicker = true">
          {{infoForm.school ? schoolList.find(v => infoForm.school == v.val).val : '请选择'}}
        </div>
        <van-popup v-model="showSchoolPicker" position="bottom">
          <van-picker
            show-toolbar
            value-key='val'
            :columns="schoolList"
            @confirm="onConfirmSchool"
            @cancel="showSchoolPicker = false"
          />
        </van-popup>
      </div> -->
      <div class="formItem clearfix" v-if="activeTab == '志愿者'">
        <div class="formName">任教学校</div>
        <div class="formIcon">
          <img src="../img/m/arrow_right.png" alt="" class="arrow">
        </div>
        <div class="formCon" style="width: 63%">
          <input type="text" placeholder="" v-model="infoForm.school">
        </div>
      </div>
      <div class="formItem clearfix" v-if="activeTab == '志愿者'">
        <div class="formName">赴任时间</div>
        <div class="formIcon">
          <img src="../img/m/calendar.png" alt="" class="calendar">
        </div>
        <div class="formCon" :class="{'conHolder': firstAppoint}" @click="showAppointPicker = true">
          {{firstAppoint ? '请选择' : new Date(infoForm.appoint_time).Format('YYYY年MM月')}}
        </div>
        <van-popup v-model="showAppointPicker" position="bottom">
          <van-datetime-picker
            v-model="infoForm.appoint_time"
            type="year-month"
            title="选择年月"
            @confirm="onConfirmAppoint"
            @cancel="showAppointPicker = false"
          />
        </van-popup>
      </div>
      <div class="formItem clearfix" v-if="activeTab == '志愿者'">
        <div class="formName">离任时间</div>
        <div class="formIcon">
          <img src="../img/m/calendar.png" alt="" class="calendar">
        </div>
        <div class="formCon" :class="{'conHolder': firstQuit}" @click="showQuitPicker = true">
          {{firstQuit ? '请选择' : new Date(infoForm.quit_time).Format('YYYY年MM月')}}
        </div>
        <van-popup v-model="showQuitPicker" position="bottom">
          <van-datetime-picker
            v-model="infoForm.quit_time"
            type="year-month"
            title="选择年月"
            @confirm="onConfirmQuit"
            @cancel="showQuitPicker = false"
          />
        </van-popup>
      </div>
      <div class="formItem clearfix" v-if="activeTab == '非志愿者'">
        <div class="formName">工作单位</div>
        <div class="formIcon">
          <img src="../img/m/arrow_right.png" alt="" class="arrow">
        </div>
        <div class="formCon">
          <input type="text" placeholder="" v-model="infoForm.work">
        </div>
      </div>
      <div class="formItem clearfix">
        <div class="formName">电子邮件</div>
        <div class="formIcon">
          <img src="../img/m/arrow_right.png" alt="" class="arrow">
        </div>
        <div class="formCon">
          <input type="text" placeholder="" v-model="infoForm.email" @change="print()">
        </div>
      </div>
      <div class="formItem clearfix">
        <div class="formName">电话</div>
        <div class="formIcon">
          <img src="../img/m/arrow_right.png" alt="" class="arrow">
        </div>
        <div class="formCon">
          <input type="text" placeholder="" v-model="infoForm.phone_number" @change="print()">
        </div>
      </div>
      <div class="formItem clearfix">
        <div class="formName">QQ</div>
        <div class="formIcon">
          <img src="../img/m/arrow_right.png" alt="" class="arrow">
        </div>
        <div class="formCon">
          <!-- <van-field v-model="digit" type="digit"/> -->
          <input type="number" placeholder="" v-model="infoForm.qq" @change="print()">
        </div>
      </div>
      <div class="formItem clearfix">
        <div class="formName">微信</div>
        <div class="formIcon">
          <img src="../img/m/arrow_right.png" alt="" class="arrow">
        </div>
        <div class="formCon">
          <input type="text" placeholder="" v-model="infoForm.wechat" @change="print()">
        </div>
      </div>
      <div class="formItem note clearfix">
        <div class="formName">备注</div>
        <div class="formCon">
          <textarea name="" id="" cols="10" rows="5" placeholder="100字以内" v-model="infoForm.remark"></textarea>
        </div>
      </div>
    </div>
    <div class="submit_btn" @click="submitForm()">
      提交
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { Notify } from 'vant'
import headerBar from './common/headerBar'

export default {
  components: {
    headerBar
  },
  data () {
    return {
      activeTab: '志愿者',
      showSexPicker: false,
      sexColumns: [
        {
          text: '男',
          id: '1'
        },
        {
          text: '女',
          id: '2'
        }
      ],
      showCountryPicker: false,
      countryList: [],
      showSchoolPicker: false,
      schoolList: [],
      showAppointPicker: false,
      firstAppoint: true,
      showQuitPicker: false,
      firstQuit: true,
      infoForm: {
        user_type: 1, // 1：志愿者 0：非志愿者
        realname: '',
        gender: undefined,
        country: undefined,
        school: null,
        otherschool: '',
        appoint_time: new Date(),
        quit_time: new Date(),
        email: '',
        work: '',
        phone_number: '',
        qq: '',
        wechat: '',
        remark: '',
      },
      reg: /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
    }
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  created () {
    this.getCountryList()
  },
  methods: {
    // 切换tab
    changeTab (name) {
      if (this.activeTab !== name) {
        this.activeTab = name
        this.firstAppoint = true
        this.firstQuit = true
        this.infoForm = {
          realname: '',
          gender: undefined,
          country: undefined,
          school: null,
          otherschool: '',
          appoint_time: new Date(),
          quit_time: new Date(),
          email: '',
          work: '',
          phone_number: '',
          qq: '',
          wechat: '',
          remark: '',
        }
        if (this.activeTab == '志愿者') {
          this.infoForm.user_type = 1
        } else {
          this.infoForm.user_type = 0
        }
      }
    },
    // 性别picker
    onConfirmSex (value) {
      this.infoForm.gender = value.id
      this.showSexPicker = false
    },
    // 国家picker
    onConfirmCountry (value) {
      this.infoForm.country = value.skey
      this.showCountryPicker = false
      if(value.skey) {
          this.$utils.get('/user/get-institute-list',{
            state_code: value.skey
          })
          .then(res => {
            res.data.list.forEach(element => {
              this.schoolList.push({
                val: element.cn_name,
                name: element.cn_name
              })
            })
            this.schoolList.push({
              val: '其它',
              name: '其它'
            })
          })
      }
    },
    // 学校picker
    onConfirmSchool (value) {
      this.infoForm.school = value.val
      this.showSchoolPicker = false
    },
    // 任职时间picker
    onConfirmAppoint (value) {
      this.firstAppoint = false
      this.infoForm.appoint_time = value
      this.showAppointPicker = false
    },
    // 离任时间picker
    onConfirmQuit (value) {
      this.firstQuit = false
      this.infoForm.quit_time = value
      this.showQuitPicker = false
    },
    getCountryList() {
      this.$utils.get('/user/get-country-list').then(res => {
        this.countryList = res.data
      })
    },
    // 提交
    submitForm () {
      if (!this.infoForm.realname) {
        Notify({ type: 'warning', message: '姓名不能为空' })
        return
      }
      if (!this.infoForm.gender) {
        Notify({ type: 'warning', message: '性别不能为空' })
        return
      }
      if (!this.infoForm.country) {
        Notify({ type: 'warning', message: '国家不能为空' })
        return
      }
      if (!this.infoForm.email) {
        Notify({ type: 'warning', message: '电子邮箱不能为空' })
        return
      }
      if (this.infoForm.user_type == 1) {
        if (!this.infoForm.school) {
          Notify({ type: 'warning', message: '任教学校不能为空' })
          return
        }
        if (this.infoForm.school == '其它' && !this.infoForm.otherschool) {
          Notify({ type: 'warning', message: '任教学校不能为空' })
          return
        }
        if (this.firstAppoint) {
          Notify({ type: 'warning', message: '开始时间不能为空' })
          return
        }
        if (this.firstQuit) {
          Notify({ type: 'warning', message: '结束时间不能为空' })
          return
        }
      } else {
        if (!this.infoForm.work) {
          Notify({ type: 'warning', message: '工作单位不能为空' })
          return
        }
      }
      if (!this.reg.test(this.infoForm.email)) {
        Notify({ type: 'warning', message: '请输入正确的邮箱' })
      }

      let dataForm = {}
      for (var index in this.infoForm) {
        dataForm[index] = this.infoForm[index]
      }
      if(dataForm.user_type == 1) {
        delete dataForm.work
        if(dataForm.school == '其它') {
          dataForm.school = dataForm.otherschool
        }
      } else {
        delete dataForm.school
        delete dataForm.otherschool
        delete dataForm.appoint_time
        delete dataForm.quit_time
      }
      this.$utils.postForm('/user/update-info', dataForm).then(res => {
        if(res.code == 1000) {
          Notify({ type: 'success', message: '报名成功！' })
        } else {
          Notify({ type: 'warning', message: res.msg })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.userinfo {
  min-height: 100vh;
  background: #ededf6;
  .content {
    padding: .3rem .45rem 0 .45rem;
    box-sizing: border-box;
    .top_content {
      background: #fff2f7;
      padding: .7rem .85rem 0 .85rem;
      .tip {
        color: #fd7777;
        font-size: .45rem;
        line-height: 1.4;
        margin-bottom: .72rem;
      }
      .tab {
        width: 50%;
        height: 1.5rem;
        line-height: 1.48rem;
        float: left;
        color: #818181;
        font-size: .6rem;
        background: #dadcde;
        text-align: center;
        &.active {
          color: #404040;
          background: #fff;
        }
      }
    }
    .formItem {
      background: #fff;
      border-bottom: .01rem solid #ccc;
      padding: .4rem .78rem .4rem .7rem;
      box-sizing: border-box;
      line-height: 1.8;
      .formName {
        font-size: .6rem;
        color: #282828;
        float: left;
      }
      .formCon {
        float: right;
        width: 75%;
        height: 1.2rem;
        padding-right: 0.4rem;
        box-sizing: border-box;
        color: #282828;
        font-size: .6rem;
        text-align: right;
        &.conHolder {
          color: #999;
        }
        input {
          width: 100%;
          height: 1.2rem;
          color: #282828;
          display: block;
          background-color: transparent;
          border: 0;
          padding: 0;
          margin: 0;
          resize: none;
          text-align: right;
        }
      }
      .formIcon {
        float: right;
        .arrow {
          width: .3rem;
          margin-top: .35rem;
        }
        .calendar {
          width: .46rem;
          margin-top: .35rem;
        }
      }
      &.note {
        .formName {
          float: none;
        }
        .formCon {
          float: none;
          text-align: left;
          width: 100%;
          height: 3rem;
          padding: 0;
          input {
            text-align: left;
          }
          textarea {
            width: 100%;
            height: 3rem;
            border: 0;
            resize: none;
            padding: 0;
          }
        }
      }
    }
  }
  .submit_btn {
    width: 100%;
    height: 2.41rem;
    background-color: #333;
    color: #fff;
    font-size: .8rem;
    text-align: center;
    line-height: 2.41rem;
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #999;
  }
}
</style>
